/* Auto-generated. Do not edit manually. */
import { ReactComponent as Block_1_64 } from "../blocks/1/land_plot_block_64.svg";
import { ReactComponent as Block_1_65 } from "../blocks/1/land_plot_block_65.svg";
import { ReactComponent as Block_1_66 } from "../blocks/1/land_plot_block_66.svg";
import { ReactComponent as Block_1_67 } from "../blocks/1/land_plot_block_67.svg";
import { ReactComponent as Block_1_68 } from "../blocks/1/land_plot_block_68.svg";
import { ReactComponent as Block_1_69 } from "../blocks/1/land_plot_block_69.svg";
import { ReactComponent as Block_1_70 } from "../blocks/1/land_plot_block_70.svg";
import { ReactComponent as Block_1_71 } from "../blocks/1/land_plot_block_71.svg";
import { ReactComponent as Block_1_72 } from "../blocks/1/land_plot_block_72.svg";
import { ReactComponent as Block_1_73 } from "../blocks/1/land_plot_block_73.svg";
import { ReactComponent as Block_1_74 } from "../blocks/1/land_plot_block_74.svg";
import { ReactComponent as Block_1_75 } from "../blocks/1/land_plot_block_75.svg";
import { ReactComponent as Block_1_76 } from "../blocks/1/land_plot_block_76.svg";
import { ReactComponent as Block_1_77 } from "../blocks/1/land_plot_block_77.svg";
import { ReactComponent as Block_1_78 } from "../blocks/1/land_plot_block_78.svg";
import { ReactComponent as Block_1_79 } from "../blocks/1/land_plot_block_79.svg";
import { ReactComponent as Block_1_80 } from "../blocks/1/land_plot_block_80.svg";
import { ReactComponent as Block_1_81 } from "../blocks/1/land_plot_block_81.svg";
import { ReactComponent as Block_1_82 } from "../blocks/1/land_plot_block_82.svg";
import { ReactComponent as Block_1_83 } from "../blocks/1/land_plot_block_83.svg";
import { ReactComponent as Block_1_84 } from "../blocks/1/land_plot_block_84.svg";
import { ReactComponent as Block_31_64 } from "../blocks/31/land_plot_block_64.svg";
import { ReactComponent as Block_31_65 } from "../blocks/31/land_plot_block_65.svg";
import { ReactComponent as Block_31_66 } from "../blocks/31/land_plot_block_66.svg";
import { ReactComponent as Block_31_67 } from "../blocks/31/land_plot_block_67.svg";
import { ReactComponent as Block_31_68 } from "../blocks/31/land_plot_block_68.svg";
import { ReactComponent as Block_31_69 } from "../blocks/31/land_plot_block_69.svg";
import { ReactComponent as Block_31_70 } from "../blocks/31/land_plot_block_70.svg";
import { ReactComponent as Block_31_71 } from "../blocks/31/land_plot_block_71.svg";
import { ReactComponent as Block_31_72 } from "../blocks/31/land_plot_block_72.svg";
import { ReactComponent as Block_31_73 } from "../blocks/31/land_plot_block_73.svg";
import { ReactComponent as Block_31_74 } from "../blocks/31/land_plot_block_74.svg";
import { ReactComponent as Block_31_75 } from "../blocks/31/land_plot_block_75.svg";
import { ReactComponent as Block_31_76 } from "../blocks/31/land_plot_block_76.svg";
import { ReactComponent as Block_31_77 } from "../blocks/31/land_plot_block_77.svg";
import { ReactComponent as Block_31_78 } from "../blocks/31/land_plot_block_78.svg";
import { ReactComponent as Block_31_79 } from "../blocks/31/land_plot_block_79.svg";
import { ReactComponent as Block_31_80 } from "../blocks/31/land_plot_block_80.svg";
import { ReactComponent as Block_31_81 } from "../blocks/31/land_plot_block_81.svg";
import { ReactComponent as Block_31_82 } from "../blocks/31/land_plot_block_82.svg";
import { ReactComponent as Block_31_83 } from "../blocks/31/land_plot_block_83.svg";
import { ReactComponent as Block_31_84 } from "../blocks/31/land_plot_block_84.svg";
import { ReactComponent as Block_61_64 } from "../blocks/61/land_plot_block_64.svg";
import { ReactComponent as Block_61_65 } from "../blocks/61/land_plot_block_65.svg";
import { ReactComponent as Block_61_66 } from "../blocks/61/land_plot_block_66.svg";
import { ReactComponent as Block_61_67 } from "../blocks/61/land_plot_block_67.svg";
import { ReactComponent as Block_61_68 } from "../blocks/61/land_plot_block_68.svg";
import { ReactComponent as Block_61_69 } from "../blocks/61/land_plot_block_69.svg";
import { ReactComponent as Block_61_70 } from "../blocks/61/land_plot_block_70.svg";
import { ReactComponent as Block_61_71 } from "../blocks/61/land_plot_block_71.svg";
import { ReactComponent as Block_61_72 } from "../blocks/61/land_plot_block_72.svg";
import { ReactComponent as Block_61_73 } from "../blocks/61/land_plot_block_73.svg";
import { ReactComponent as Block_61_74 } from "../blocks/61/land_plot_block_74.svg";
import { ReactComponent as Block_61_75 } from "../blocks/61/land_plot_block_75.svg";
import { ReactComponent as Block_61_76 } from "../blocks/61/land_plot_block_76.svg";
import { ReactComponent as Block_61_77 } from "../blocks/61/land_plot_block_77.svg";
import { ReactComponent as Block_61_78 } from "../blocks/61/land_plot_block_78.svg";
import { ReactComponent as Block_61_79 } from "../blocks/61/land_plot_block_79.svg";
import { ReactComponent as Block_61_80 } from "../blocks/61/land_plot_block_80.svg";
import { ReactComponent as Block_61_81 } from "../blocks/61/land_plot_block_81.svg";
import { ReactComponent as Block_61_82 } from "../blocks/61/land_plot_block_82.svg";
import { ReactComponent as Block_61_83 } from "../blocks/61/land_plot_block_83.svg";
import { ReactComponent as Block_61_84 } from "../blocks/61/land_plot_block_84.svg";
import { ReactComponent as Block_91_64 } from "../blocks/91/land_plot_block_64.svg";
import { ReactComponent as Block_91_65 } from "../blocks/91/land_plot_block_65.svg";
import { ReactComponent as Block_91_66 } from "../blocks/91/land_plot_block_66.svg";
import { ReactComponent as Block_91_67 } from "../blocks/91/land_plot_block_67.svg";
import { ReactComponent as Block_91_68 } from "../blocks/91/land_plot_block_68.svg";
import { ReactComponent as Block_91_69 } from "../blocks/91/land_plot_block_69.svg";
import { ReactComponent as Block_91_70 } from "../blocks/91/land_plot_block_70.svg";
import { ReactComponent as Block_91_71 } from "../blocks/91/land_plot_block_71.svg";
import { ReactComponent as Block_91_72 } from "../blocks/91/land_plot_block_72.svg";
import { ReactComponent as Block_91_73 } from "../blocks/91/land_plot_block_73.svg";
import { ReactComponent as Block_91_74 } from "../blocks/91/land_plot_block_74.svg";
import { ReactComponent as Block_91_75 } from "../blocks/91/land_plot_block_75.svg";
import { ReactComponent as Block_91_76 } from "../blocks/91/land_plot_block_76.svg";
import { ReactComponent as Block_91_77 } from "../blocks/91/land_plot_block_77.svg";
import { ReactComponent as Block_91_78 } from "../blocks/91/land_plot_block_78.svg";
import { ReactComponent as Block_91_79 } from "../blocks/91/land_plot_block_79.svg";
import { ReactComponent as Block_91_80 } from "../blocks/91/land_plot_block_80.svg";
import { ReactComponent as Block_91_81 } from "../blocks/91/land_plot_block_81.svg";
import { ReactComponent as Block_91_82 } from "../blocks/91/land_plot_block_82.svg";
import { ReactComponent as Block_91_83 } from "../blocks/91/land_plot_block_83.svg";
import { ReactComponent as Block_91_84 } from "../blocks/91/land_plot_block_84.svg";

export const zone2_block_polygons = [
    {
        wrapperIndex: 2,
        areas: [
            {
                blockIndex: 64,
                Polygon: Block_1_64,
            },
            {
                blockIndex: 65,
                Polygon: Block_1_65,
            },
            {
                blockIndex: 66,
                Polygon: Block_1_66,
            },
            {
                blockIndex: 67,
                Polygon: Block_1_67,
            },
            {
                blockIndex: 68,
                Polygon: Block_1_68,
            },
            {
                blockIndex: 69,
                Polygon: Block_1_69,
            },
            {
                blockIndex: 70,
                Polygon: Block_1_70,
            },
            {
                blockIndex: 71,
                Polygon: Block_1_71,
            },
            {
                blockIndex: 72,
                Polygon: Block_1_72,
            },
            {
                blockIndex: 73,
                Polygon: Block_1_73,
            },
            {
                blockIndex: 74,
                Polygon: Block_1_74,
            },
            {
                blockIndex: 75,
                Polygon: Block_1_75,
            },
            {
                blockIndex: 76,
                Polygon: Block_1_76,
            },
            {
                blockIndex: 77,
                Polygon: Block_1_77,
            },
            {
                blockIndex: 78,
                Polygon: Block_1_78,
            },
            {
                blockIndex: 79,
                Polygon: Block_1_79,
            },
            {
                blockIndex: 80,
                Polygon: Block_1_80,
            },
            {
                blockIndex: 81,
                Polygon: Block_1_81,
            },
            {
                blockIndex: 82,
                Polygon: Block_1_82,
            },
            {
                blockIndex: 83,
                Polygon: Block_1_83,
            },
            {
                blockIndex: 84,
                Polygon: Block_1_84,
            },
        ],
    },
    {
        wrapperIndex: 32,
        areas: [
            {
                blockIndex: 64,
                Polygon: Block_31_64,
            },
            {
                blockIndex: 65,
                Polygon: Block_31_65,
            },
            {
                blockIndex: 66,
                Polygon: Block_31_66,
            },
            {
                blockIndex: 67,
                Polygon: Block_31_67,
            },
            {
                blockIndex: 68,
                Polygon: Block_31_68,
            },
            {
                blockIndex: 69,
                Polygon: Block_31_69,
            },
            {
                blockIndex: 70,
                Polygon: Block_31_70,
            },
            {
                blockIndex: 71,
                Polygon: Block_31_71,
            },
            {
                blockIndex: 72,
                Polygon: Block_31_72,
            },
            {
                blockIndex: 73,
                Polygon: Block_31_73,
            },
            {
                blockIndex: 74,
                Polygon: Block_31_74,
            },
            {
                blockIndex: 75,
                Polygon: Block_31_75,
            },
            {
                blockIndex: 76,
                Polygon: Block_31_76,
            },
            {
                blockIndex: 77,
                Polygon: Block_31_77,
            },
            {
                blockIndex: 78,
                Polygon: Block_31_78,
            },
            {
                blockIndex: 79,
                Polygon: Block_31_79,
            },
            {
                blockIndex: 80,
                Polygon: Block_31_80,
            },
            {
                blockIndex: 81,
                Polygon: Block_31_81,
            },
            {
                blockIndex: 82,
                Polygon: Block_31_82,
            },
            {
                blockIndex: 83,
                Polygon: Block_31_83,
            },
            {
                blockIndex: 84,
                Polygon: Block_31_84,
            },
        ],
    },
    {
        wrapperIndex: 62,
        areas: [
            {
                blockIndex: 64,
                Polygon: Block_61_64,
            },
            {
                blockIndex: 65,
                Polygon: Block_61_65,
            },
            {
                blockIndex: 66,
                Polygon: Block_61_66,
            },
            {
                blockIndex: 67,
                Polygon: Block_61_67,
            },
            {
                blockIndex: 68,
                Polygon: Block_61_68,
            },
            {
                blockIndex: 69,
                Polygon: Block_61_69,
            },
            {
                blockIndex: 70,
                Polygon: Block_61_70,
            },
            {
                blockIndex: 71,
                Polygon: Block_61_71,
            },
            {
                blockIndex: 72,
                Polygon: Block_61_72,
            },
            {
                blockIndex: 73,
                Polygon: Block_61_73,
            },
            {
                blockIndex: 74,
                Polygon: Block_61_74,
            },
            {
                blockIndex: 75,
                Polygon: Block_61_75,
            },
            {
                blockIndex: 76,
                Polygon: Block_61_76,
            },
            {
                blockIndex: 77,
                Polygon: Block_61_77,
            },
            {
                blockIndex: 78,
                Polygon: Block_61_78,
            },
            {
                blockIndex: 79,
                Polygon: Block_61_79,
            },
            {
                blockIndex: 80,
                Polygon: Block_61_80,
            },
            {
                blockIndex: 81,
                Polygon: Block_61_81,
            },
            {
                blockIndex: 82,
                Polygon: Block_61_82,
            },
            {
                blockIndex: 83,
                Polygon: Block_61_83,
            },
            {
                blockIndex: 84,
                Polygon: Block_61_84,
            },
        ],
    },
    {
        wrapperIndex: 92,
        areas: [
            {
                blockIndex: 64,
                Polygon: Block_91_64,
            },
            {
                blockIndex: 65,
                Polygon: Block_91_65,
            },
            {
                blockIndex: 66,
                Polygon: Block_91_66,
            },
            {
                blockIndex: 67,
                Polygon: Block_91_67,
            },
            {
                blockIndex: 68,
                Polygon: Block_91_68,
            },
            {
                blockIndex: 69,
                Polygon: Block_91_69,
            },
            {
                blockIndex: 70,
                Polygon: Block_91_70,
            },
            {
                blockIndex: 71,
                Polygon: Block_91_71,
            },
            {
                blockIndex: 72,
                Polygon: Block_91_72,
            },
            {
                blockIndex: 73,
                Polygon: Block_91_73,
            },
            {
                blockIndex: 74,
                Polygon: Block_91_74,
            },
            {
                blockIndex: 75,
                Polygon: Block_91_75,
            },
            {
                blockIndex: 76,
                Polygon: Block_91_76,
            },
            {
                blockIndex: 77,
                Polygon: Block_91_77,
            },
            {
                blockIndex: 78,
                Polygon: Block_91_78,
            },
            {
                blockIndex: 79,
                Polygon: Block_91_79,
            },
            {
                blockIndex: 80,
                Polygon: Block_91_80,
            },
            {
                blockIndex: 81,
                Polygon: Block_91_81,
            },
            {
                blockIndex: 82,
                Polygon: Block_91_82,
            },
            {
                blockIndex: 83,
                Polygon: Block_91_83,
            },
            {
                blockIndex: 84,
                Polygon: Block_91_84,
            },
        ],
    },
];